import { create } from "zustand";
import { LOG } from "../utils/logUtil";
import axios from "axios";

interface IStatigieldStats {
  totalStatiegeldDrops: number;
  totalItemsCount: number;
  totalRefundAmount: number;
  supergroupStats: {
    superGroup: number;
    totalItems: number;
    totalRefund: number;
  }[];
  gtinStats: {
    barcode: number;
    totalItems: number;
    totalRefund: number;
  }[];
}

interface IStore {
  statiegeldStats: IStatigieldStats | null;
  getStatiegeldStats: () => void;
}

export const useStatiegeldStats = create<IStore>()((set) => ({
  statiegeldStats: null,
  getStatiegeldStats: async () => {
    try {
      const response = await axios.get("/statiegeld-stats");
      if (response?.data) {
        set({ statiegeldStats: response.data });
      }
    } catch (error) {
      LOG.error("Error on fetching Statiegeld stats", { error });
    }
  },
}));
